import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// 导入翻译资源
import zhCN from './locales/zh-CN.json'
import enUS from './locales/en-US.json'
import viVN from './locales/vi-VN.json'
import idID from './locales/id-ID.json'
import thTH from './locales/th-TH.json'
import msMY from './locales/ms-MY.json'
import msBN from './locales/ms-BN.json'
import kmKH from './locales/km-KH.json'
import loLA from './locales/lo-LA.json'
import myMM from './locales/my-MM.json'

const resources = {
  'zh-CN': {
    translation: zhCN
  },
  'en-US': {
    translation: enUS
  },
  'vi-VN': {
    translation: viVN
  },
  'id-ID': {
    translation: idID
  },
  'th-TH': {
    translation: thTH
  },
  'ms-MY': {
    translation: msMY
  },
  'ms-BN': {
    translation: msBN
  },
  'km-KH': {
    translation: kmKH
  },
  'lo-LA': {
    translation: loLA
  },
  'my-MM': {
    translation: myMM
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-CN',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    }
  })

export default i18n 